/*------------------------------------------------------------------
[React]
-------------------------------------------------------------------*/
import React, {useEffect, useState, useRef } from "react";
/*------------------------------------------------------------------
[End React]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Helmet]
-------------------------------------------------------------------*/
import {Helmet} from "react-helmet";
/*------------------------------------------------------------------
[End React Helmet]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[React Router]
-------------------------------------------------------------------*/
import { useParams, useHistory, useLocation, Link, NavLink } from "react-router-dom";
/*------------------------------------------------------------------
[End React Router]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Socket.io]
-------------------------------------------------------------------*/
import io from "socket.io-client";
/*------------------------------------------------------------------
[End Socket.io]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[API]
-------------------------------------------------------------------*/
import { API_GET_REQUEST, API_POST, API_URL, API_SERVER, API_SCT } from '../../../api';
/*------------------------------------------------------------------
[End API]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Module]
-------------------------------------------------------------------*/
import axios from 'axios'
import {reactLocalStorage} from 'reactjs-localstorage';
import {encode, decode} from 'html-entities'
import CurrencyFormat from 'react-currency-format';
import Tour from 'reactour'
/*------------------------------------------------------------------
[End Module]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Functions]
-------------------------------------------------------------------*/
import { random_character, console_dev } from '../../../functions'
/*------------------------------------------------------------------
[End Functions]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Etc]
-------------------------------------------------------------------*/
import ComponentsCredit from '../@sims/@components/credit'
import OverlayBg from '../../../assets/img/overlay_bg_form.png'
/*------------------------------------------------------------------
[End Etc]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Veriable]
-------------------------------------------------------------------*/
let SOCKET_SERVER = process.env.REACT_APP_PRODUCTION === 'false' ? process.env.REACT_APP_SOCKET_SERVER_DEVELOPMENT : process.env.REACT_APP_SOCKET_SERVER_PRODUCTION;
let socket = io(SOCKET_SERVER);
/*------------------------------------------------------------------
[End Variable]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Screens]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[Components]
-------------------------------------------------------------------*/

/*------------------------------------------------------------------
[End Components]
-------------------------------------------------------------------*/

const Screen = ({loading, error, progress}) => {

    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/
    const { slug } = useParams();
    /*--------------------------------------------------------------
    [Slug]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [History]
    ----------------------------------------------------------------*/
    const history = useHistory();
    /*--------------------------------------------------------------
    [End History]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [useLocation]
    ----------------------------------------------------------------*/
    const useQuery = () => {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery(); // query.get("order_id")
    /*--------------------------------------------------------------
    [End useLocation]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [Storage]
    ----------------------------------------------------------------*/
    let STORAGE_TOKEN = reactLocalStorage.get('@token');
    let STORAGE_USER_STRINGIFY = reactLocalStorage.get('@user');

	let STORAGE_USER;

	if(STORAGE_USER_STRINGIFY){
		STORAGE_USER = JSON.parse(STORAGE_USER_STRINGIFY)
	}
    /*--------------------------------------------------------------
    [End Storage]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Meta]
    ----------------------------------------------------------------*/
    let meta_title = 'Murid';
    /*--------------------------------------------------------------
    [End Meta]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route API]
    ----------------------------------------------------------------*/
    let route_api = 'school';
    /*--------------------------------------------------------------
    [End Route API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Route Path]
    ----------------------------------------------------------------*/
    let route_path = 'murid';
    /*--------------------------------------------------------------
    [End Route Path]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Request Params]
    ----------------------------------------------------------------*/
    let request_params = 'murid';
    /*--------------------------------------------------------------
    [End Request Params]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Private]
    ----------------------------------------------------------------*/
    let PRIVATE = true;
    /*--------------------------------------------------------------
    [End Private]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Pagination Offset]
    ----------------------------------------------------------------*/
    let pagination_offset = 20;
    /*--------------------------------------------------------------
    [End Pagination Offset]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [State]
    ----------------------------------------------------------------*/
    const [tour, set_tour] = useState(false);
    const [tab, set_tab] = useState(null);
    const [filter, set_filter] = useState(null);
    const [sub_filter, set_sub_filter] = useState(null);

    const [refresh, set_refresh] = useState(null);
    const [queue, set_queue] = useState(false)
    const [file, set_file] = useState(null);
    const [bamboo_user, set_bamboo_user] = useState(null);
    const [bamboo_update, set_bamboo_update] = useState('');
    const [bamboo_delete, set_bamboo_delete] = useState('');

    const [table_height, set_table_height] = useState(0);

    const [element, set_element] = useState(null);
    const [sub_element, set_sub_element] = useState(null);
    const [end_element, set_end_element] = useState(null);
    
    const [pagination_active, set_pagination_active] = useState(1);
    const [path_client, set_path_client] = useState('')
    const [data, set_data] = useState(null);
    const [search, set_search] = useState('');
    /*--------------------------------------------------------------
    [End State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [New State]
    ----------------------------------------------------------------*/
    const [test, set_test] = useState('')

    const [nis, set_nis] = useState('')
    const [nama_murid, set_nama_murid] = useState('')
    const [nama_lengkap, set_nama_lengkap] = useState('')
    const [jenis_kelamin, set_jenis_kelamin] = useState('')
    const [kelahiran, set_kelahiran] = useState('')
    const [tempat_lahir, set_tempat_lahir] = useState('')
    const [tanggal_lahir, set_tanggal_lahir] = useState('')
    const [agama, set_agama] = useState('')
    const [kewarganegaraan, set_kewarganegaraan] = useState('')
    const [anak_ke, set_anak_ke] = useState('')
    const [jumlah_saudara, set_jumlah_saudara] = useState('')
    const [bahasa, set_bahasa] = useState('')
    const [golongan_darah, set_golongan_darah] = useState('')
    const [alamat, set_alamat] = useState('')
    const [rtrw, set_rtrw] = useState('')
    const [desa, set_desa] = useState('')
    const [kecamatan, set_kecamatan] = useState('')
    const [kabupaten, set_kabupaten] = useState('')
    const [provinsi, set_provinsi] = useState('')
    const [no_telepon, set_no_telepon] = useState('')
    const [bertempat_tinggal, set_bertempat_tinggal] = useState('')
    const [jarak_ke_sekolah, set_jarak_ke_sekolah] = useState('')
    const [nama_ayah, set_nama_ayah] = useState('')
    const [nama_ibu, set_nama_ibu] = useState('')
    const [pendidikan_ayah, set_pendidikan_ayah] = useState('')
    const [pendidikan_ibu, set_pendidikan_ibu] = useState('')
    const [pekerjaan_ayah, set_pekerjaan_ayah] = useState('')
    const [pekerjaan_ibu, set_pekerjaan_ibu] = useState('')
    const [nama_wali_murid, set_nama_wali_murid] = useState('')
    const [hubungan_wali_murid, set_hubungan_wali_murid] = useState('')
    const [pendidikan_wali_murid, set_pendidikan_wali_murid] = useState('')
    const [pekerjaan_wali_murid, set_pekerjaan_wali_murid] = useState('')
    const [asal_sekolah, set_asal_sekolah] = useState('')
    const [nama_sekolah, set_nama_sekolah] = useState('')
    const [tanggal_dan_no_ijazah, set_tanggal_dan_no_ijazah] = useState('')
    const [nama_sekolah_asal, set_nama_sekolah_asal] = useState('')
    const [dari_tingkat, set_dari_tingkat] = useState('')
    const [diterima_tanggal, set_diterima_tanggal] = useState('')
    const [no_surat_keterangan, set_no_surat_keterangan] = useState('')
    const [tinggi_badan, set_tinggi_badan] = useState('')
    const [berat_badan, set_berat_badan] = useState('')
    const [prestasi, set_prestasi] = useState('')
    const [tahun_lulus, set_tahun_lulus] = useState('')
    const [no_ijazah_sttb, set_no_ijazah_sttb] = useState('')
    const [melanjutkan_ke_sekolah, set_melanjutkan_ke_sekolah] = useState('')
    const [alasan_keluar, set_alasan_keluar] = useState('')
    const [hari_tanggal_keluar, set_hari_tanggal_keluar] = useState('')
    const [catatan, set_catatan] = useState('')
    /*--------------------------------------------------------------
    [End New State]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Looping Input]
    ----------------------------------------------------------------*/
    const input = [
        {
            name : 'nis',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'uppercase', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : 'nama_murid',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : 'nama_lengkap',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : 'jenis_kelamin',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'kelahiran',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'tempat_lahir',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'tanggal_lahir',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'agama',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'kewarganegaraan',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'anak_ke',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'jumlah_saudara',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'bahasa',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'golongan_darah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'alamat',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'rtrw',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'desa',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'kecamatan',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'kabupaten',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'provinsi',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'no_telepon',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: true,
            data: null
        },
        {
            name : 'bertempat_tinggal',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'jarak_ke_sekolah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'nama_ayah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'nama_ibu',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'pendidikan_ayah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'pendidikan_ibu',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'pekerjaan_ayah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'pekerjaan_ibu',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'nama_wali_murid',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'hubungan_wali_murid',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'pendidikan_wali_murid',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'pekerjaan_wali_murid',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'asal_sekolah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'nama_sekolah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'tanggal_dan_no_ijazah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'nama_sekolah_asal',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'dari_tingkat',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'diterima_tanggal',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'no_surat_keterangan',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'tinggi_badan',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'berat_badan',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'prestasi',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'tahun_lulus',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'no_ijazah_sttb',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'melanjutkan_ke_sekolah',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'alasan_keluar',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'hari_tanggal_keluar',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },
        {
            name : 'catatan',
            element : 'text', // text, dropdown, money, file 
            text_transform : 'capitalize', // capitalize, uppercase
            show_table: false,
            data: null
        },

        {
            name : 'submit',
            element : 'submit',
            text_transform : 'capitalize',
            submit_file: false
        }
    ]

    const input_obj = {
        nis: nis,
        nama_murid : nama_murid,
        nama_lengkap : nama_lengkap,
        jenis_kelamin : jenis_kelamin,
        kelahiran : kelahiran,
        tempat_lahir : tempat_lahir,
        tanggal_lahir : tanggal_lahir,
        agama : agama,
        kewarganegaraan : kewarganegaraan,
        anak_ke : anak_ke,
        jumlah_saudara : jumlah_saudara,
        bahasa : bahasa,
        golongan_darah : golongan_darah,
        alamat : alamat,
        rtrw : rtrw,
        desa : desa,
        kecamatan : kecamatan,
        kabupaten : kabupaten,
        provinsi : provinsi,
        no_telepon : no_telepon,
        bertempat_tinggal : bertempat_tinggal,
        jarak_ke_sekolah : jarak_ke_sekolah,
        nama_ayah : nama_ayah,
        nama_ibu : nama_ibu,
        pendidikan_ayah : pendidikan_ayah,
        pendidikan_ibu : pendidikan_ibu,
        pekerjaan_ayah : pekerjaan_ayah,
        pekerjaan_ibu : pekerjaan_ibu,
        nama_wali_murid : nama_wali_murid,
        hubungan_wali_murid : hubungan_wali_murid,
        pendidikan_wali_murid : pendidikan_wali_murid,
        pekerjaan_wali_murid : pekerjaan_wali_murid,
        asal_sekolah : asal_sekolah,
        nama_sekolah : nama_sekolah,
        tanggal_dan_no_ijazah : tanggal_dan_no_ijazah,
        nama_sekolah_asal : nama_sekolah_asal,
        dari_tingkat : dari_tingkat,
        diterima_tanggal : diterima_tanggal,
        no_surat_keterangan : no_surat_keterangan,
        tinggi_badan : tinggi_badan,
        berat_badan : berat_badan,
        prestasi : prestasi,
        tahun_lulus : tahun_lulus,
        no_ijazah_sttb : no_ijazah_sttb,
        melanjutkan_ke_sekolah : melanjutkan_ke_sekolah,
        alasan_keluar : alasan_keluar,
        hari_tanggal_keluar : hari_tanggal_keluar,
        catatan : catatan,
    }
    /*--------------------------------------------------------------
    [End Looping input]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Ref]
    ----------------------------------------------------------------*/
    const ref_table_height = useRef(null)
    /*--------------------------------------------------------------
    [End Ref]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/
    const steps = [
        {
          selector: '.___step_1',
          content: 'Content 1',
        },
    ];
    /*--------------------------------------------------------------
    [Tour Guide]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [API]
    ----------------------------------------------------------------*/
    const _read = (pages, bambooUserParams) => {

		let offsetSync;

        if(pages === 1){
            
            offsetSync = 0;    
        
        }else{

            offsetSync = pages ? (pagination_offset * pages) - pagination_offset : 0
        
        }

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=read_${request_params}`
            + '&bamboo_user=' + bambooUserParams
            + '&limit=' + pagination_offset
            + '&offset=' + offsetSync
        , 
		).then((response) => {
            console_dev(`response ${request_params} read`, response.data)
            if(response.data.result == 'success'){
                set_data(response.data.data)
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}

    const _search = () => {

        if(queue === true){
            return
        }
        
        if(search.length > 3){

            set_queue(true)
    
            API_GET_REQUEST(`${route_api}/${route_path}/get__________?action=search_${request_params}`
                + '&bamboo_user=' + bamboo_user
                + '&search=' + search
            , 
            ).then((response) => {
                console_dev(`response ${request_params} search`, response.data)
                if(response.data.result == 'success'){
                    set_data(response.data.data)
                    error('')
                }else if(response.data.error){
                    error(response.data.error);
                    set_data(null)
                }
            })
            .catch((e) => {
                console_dev('catch', e)
                error(e.message)
            }).finally(() => {
                loading(false)
                set_queue(false)
            })

        }

    }

    const _uploads = (action) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

        var data = new FormData();
        data.append("sct", API_SCT);
        data.append("key", STORAGE_USER[0].id_key);
        data.append("bamboo_user", bamboo_user);
        data.append("bamboo_update", bamboo_update);
        data.append("bamboo_delete", bamboo_delete);
        data.append("path_client", path_client);
        data.append("action", action);
        // new request --------------------------------
        data.append("test", test);
        
        input && input.map((x, i)=> {
            if(x.element !== 'submit' && x.element !== 'file'){
                data.append(x.name, eval(x.name))
            }
        })

        if(file !== null){
            file.map((item) => (
                data.append("file", item)
            ))
        }

        var config = {
            method: 'post',
            url: API_URL + `${route_api}/${route_path}/post__________`,
            headers: { 
                'Authorization': `Bearer ${STORAGE_TOKEN}`,
            },
            data : data,
            onUploadProgress: progressEvent => {
                console.log('loaded : ', progressEvent.loaded)
                console.log('total : ', progressEvent.total)
                if(file !== null){
                    progress(parseInt(Math.round((progressEvent.loaded/progressEvent.total) * 100)))
                }
            }
        };

        axios(config)
        .then((response) => {
            console_dev(`response ${request_params} uploads`, response.data)
            if(response.data.result === 'success'){
                _read(pagination_active, bamboo_user)
                set_file(null)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                set_path_client('')
                // update state ------------------
                set_test('')
                
                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })
            }else if(response.data.error){
                error(response.data.error)
            }
        })
        .catch((e) => {
            console_dev('catch', e)
            error(e.message)
        })
        .finally(() => {
			loading(false);
            set_queue(false)
		})

    }

    const _uploads_post = (params) => {

        if(queue === true){
            return
        }
        
        loading(true)
        set_queue(true)

		API_POST(`${route_api}/${route_path}/post__________`, {
            bamboo_user: bamboo_user,
            bamboo_update: bamboo_update,
            bamboo_delete: bamboo_delete,
            action: params,
            // new request ------------------------
            test: test,
            ...input_obj
		}).then((response) => {
            console_dev(`response ${request_params} uploads post`, response.data)
            if(response.data.result == 'success'){
                _read(pagination_active, bamboo_user)
                error(response.data.title)
                set_element(null)
                set_bamboo_delete('')
                set_bamboo_update('')
                // update state ------------------
                set_test('')

                input.map((x, i)=> {
                    if(x.element !== 'submit'){
                        eval('set_' + x.name)('')
                    }
                })
			}else if(response.data.error){
				error(response.data.error);
			}
		})
		.catch((e) => {
            console_dev('catch', e)
            error(e.message)
        }).finally(() => {
            loading(false)
            set_queue(false)
        })

	}
    /*--------------------------------------------------------------
    [End API]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Socket]
    ----------------------------------------------------------------*/
    const _socket_online = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'connect',
        //     room: 'room_forum_user_authentication',
        //     status: 'online',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}

    const _socket_offline = (storageUserParams) => {

        // // get
		// socket.on("get", (data) => {
		// 	console.log('get : ', data)	
		// })
		
		// // push
		// socket.emit("push", {
		// 	push : data,
		// });

        // socket.on("forum_user_authentication", (data) => {
		// 	console.log('forum_user_authentication : ', data)	
		// })

        // socket.emit("forum_user_authentication", {
        //     action: 'disconnect',
        //     room: 'room_forum_user_authentication',
        //     status: 'offline',
        //     bamboo_user : storageUserParams.bamboo,
        //     username : storageUserParams.username,
        //     name : storageUserParams.name,
        //     e_account : storageUserParams.e_account,
        // });
		
	}
    /*--------------------------------------------------------------
    [End Socket]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Functions]
    ----------------------------------------------------------------*/
    const _files = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        if(event){
            if(!event.target.files[0]){
                return error('File Dibatalkan')
            }
            
            if(event.target.files[0].size > 2048000){
                return error('Ukuran File maxsimal 2MB')
            }else{
                error('')
            }
        }

        let foo = event.target.files[0]; 

        set_file([foo]);

	};
    
    const _files_multiple = (event) => {

        if(!event){
            return error('Terjadi Kesalahan')
        }
        
        let data = [...event.target.files]
        
        if(data){

            console_dev('data', data)

            data.map((item, index) => {
                // console.log('item', data)
                if(item.size > 2048000){
                    return error('Ukuran File maxsimal 2MB')
                }else{
                    set_file([...data])
                }

            })

        }
        
	};
    /*--------------------------------------------------------------
    [End Functions]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Storage User]
    ----------------------------------------------------------------*/
    const _STORAGE_USER = () => {

        if(STORAGE_USER !== undefined){

            let storage_bamboo = STORAGE_USER[0].bamboo;
            let storage_bamboo_chain = STORAGE_USER[0].level === 'admin' ? STORAGE_USER[0].bamboo : STORAGE_USER[0].bamboo_chain;
            
            set_bamboo_user(storage_bamboo)
            _socket_online(STORAGE_USER[0])
            _read(1, storage_bamboo)
            
        }else{

            error('User Not Found')
        
        }

    }
    /*--------------------------------------------------------------
    [End Storage User]
    ----------------------------------------------------------------*/

    /*--------------------------------------------------------------
    [Authentication]
    ----------------------------------------------------------------*/
    if(PRIVATE === true){
        if(STORAGE_USER !== undefined){
            if(STORAGE_USER[0].level === 'guest'){
                history.push('/')
            }
        }else{
            history.push('/home')
            window.location.reload();
        }
    }
    /*--------------------------------------------------------------
    [End Authentication]
    ----------------------------------------------------------------*/
    
    /*--------------------------------------------------------------
    [useEffect]
    ----------------------------------------------------------------*/
    useEffect(() => {

        if(search.length > 0){
            _search()
        }else{
            _STORAGE_USER()
        }

        console_dev('input length array', input.length)

    }, [refresh, search])

    useEffect(() => {

        if(ref_table_height.current){
            set_table_height(ref_table_height.current.clientHeight + 10)
        }

    }, [data])
    /*--------------------------------------------------------------
    [End useEffect]
    ----------------------------------------------------------------*/

    return (
        <>

            {/*  Helmet ------------------------------------------------------------------ */}
            <Helmet>

                <meta name="description" content={`${meta_title}`}/>
                <title>{`${meta_title}`}</title>

            </Helmet>
            {/*  End Helmet -------------------------------------------------------------- */}

            {/*  Tour -------------------------------------------------------------------- */}
            <Tour steps={steps} isOpen={tour} onRequestClose={() => set_tour(false)} />
            <Tour disableKeyboardNavigation={['esc']} />
            {/*  End Tour ---------------------------------------------------------------- */}

            {/*  Header ------------------------------------------------------------------ */}
            <div className="_row _center_align">
                <div className="_column">
                    <h1 style={{marginBottom: 30}}><span style={{color: '#118ab2'}}>e-</span>{meta_title}</h1>
                </div>
            </div>
            
            <div className="_row _center_align _push_b_d">
                <ion-icon name="leaf-outline" style={{fontSize: 20}}></ion-icon>
                <p className="_push_l_m">Kendali penuh untuk mengatur bagian {meta_title}</p>
            </div>
            {/*  End Header --------------------------------------------------------------- */}

            {/*  Add ---------------------------------------------------------------------- */}
            <div className="_row _center_align _push_b_d">
                <div className="_column">
                    <div className="_font_size_20px">Data Cloud <ion-icon name="cloud-done-outline" style={{fontSize: 30, marginBottom: -6, marginLeft: 8, color: 'seagreen'}}></ion-icon></div>
                </div>
                <div>
                    <div onClick={() => {
                        if(element === 'overlay'){
                            set_element(null)
                        }else{
                            set_element('overlay')
                        }
                    }} className="_btn _cursor_pointer">
                        Tambah
                    </div>

                    {
                        element === 'overlay' ?
                            <>
                                <div className="_fmc_overlay">
                                    <div className="_fmc_overlay_navbar">
                                        <div className="_row _center_align">
                                            <div className="_column">
                                                <p className="_font_size_18px">Tambah Data</p>
                                            </div>
                                            <div onClick={() => {
                                                if(element === 'overlay'){
                                                    set_element(null)
                                                }else{
                                                    set_element('overlay')
                                                }
                                            }} className="_push_l_d _btn _cursor_pointer">
                                                Keluar
                                            </div>
                                        </div>
                                    </div>
                                    <div className="_fmc_overlay_content">
                                        <div className="_container">
                                            <div className="_lily_pad_h_d">
                                                <div className="_row _push_t_g _push_b_g">
                                                    <div className="_column">
                                                        <div className="_heading_bold _push_b_l">
                                                            Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                                        </div>
                                                        {
                                                            input && input.map((item, index) => (
                                                                <>
                                                                    <div key={index} className="_relative _push_b_d">
                                                                        <p style={{color: '#888', fontSize: 13, textTransform: item.text_transform}}>
                                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                            {
                                                                                item.name.replace(/_/g, " ")
                                                                            }
                                                                        </p>
                                                                        {
                                                                            item.element === 'text' ?
                                                                                <div className="_e_input">
                                                                                    <input 
                                                                                        placeholder=""
                                                                                        type={'text'} 
                                                                                        onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                                        value={eval(item.name)}
                                                                                    />
                                                                                </div>
                                                                            : item.element === 'dropdown' ?                  
                                                                                <div className="_e_input">
                                                                                    <div className="_row _center_align">
                                                                                        <div className="_column">
                                                                                            <input 
                                                                                                placeholder=""
                                                                                                type={'text'} 
                                                                                                onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                                                value={eval(item.name)}
                                                                                            />
                                                                                        </div>
                                                                                        <div onClick={() => {
                                                                                            if(sub_element === item.name + index){
                                                                                                set_sub_element(null)
                                                                                            }else{
                                                                                                set_sub_element(item.name + index)
                                                                                            }
                                                                                        }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === item.name + index ? '#eee' : null}}>
                                                                                            <div className="_row _center_align">
                                                                                                <div className="_push_t_t">
                                                                                                    {
                                                                                                        sub_element === item.name + index ?
                                                                                                            <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                                        :
                                                                                                            <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                                    }
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                    <div className="_relative">
                                                                                        {
                                                                                            sub_element === item.name + index ?
                                                                                                // _left or _right
                                                                                                <>
                                                                                                    <div className="_fmc_overlay_dropdown _right">
                                                                                                        {
                                                                                                            item.data && item.data.map((x, i) => (
                                                                                                                <div key={i} onClick={() => {eval('set_' + item.name)(x.name)}} className="_item" style={{backgroundColor: eval('set_' + item.name) === x.name ? '#eee' : null}}>{x.name}</div>
                                                                                                            ))
                                                                                                        }                                                                                                    </div>
                                                                                                </>
                                                                                            : null
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            : item.element === 'money' ?
                                                                                <div className="_relative _push_b_d">
                                                                                    <p style={{color: '#888', fontSize: 13}}>
                                                                                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                                        Input
                                                                                    </p>
                                                                                    <div className="_e_input">
                                                                                        <div className="_row _center_align">
                                                                                            <div className="_push_r_t">
                                                                                                Rp.
                                                                                            </div>
                                                                                            <div className="_column">
                                                                                                <CurrencyFormat 
                                                                                                    value={input} 
                                                                                                    thousandSeparator={true} 
                                                                                                    prefix={''}
                                                                                                    onValueChange={(e) => {
                                                                                                        if(e.value.length < 10){
                                                                                                            set_input(e.value)
                                                                                                        }else{
                                                                                                            set_input('')
                                                                                                            error('Max Length')
                                                                                                        }
                                                                                                    }}
                                                                                                />
                                                                                            </div>
                                                                                        </div>
                                                                                    </div>
                                                                                </div>
                                                                            : item.element === 'file' ?
                                                                                <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                                                    <div className="_e_input">
                                                                                        <input
                                                                                            className="custom-file-input" 
                                                                                            type="file"
                                                                                            name="file"
                                                                                            placeholder=""
                                                                                            onChange={_files}
                                                                                        />
                                                                                    </div>
                                                                                </div>
                                                                            : item.element === 'submit' ?
                                                                                <div className="_push_t_d">
                                                                                    <div onClick={() => {
                                                                                        if(item.submit_file === true){
                                                                                            _uploads(`insert_${request_params}`)
                                                                                        }else{
                                                                                            _uploads_post(`insert_${request_params}`)
                                                                                        }
                                                                                    }} className="_btn _cursor_pointer">
                                                                                        Simpan
                                                                                    </div>
                                                                                </div>
                                                                            : null
                                                                        }
                                                                    </div>
                                                                </>
                                                            ))
                                                        }
                                                    </div>
                                                    <div className="_fmc_overlay_bg_hide">
                                                        <img style={{width: 400}} src={OverlayBg}/>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : null
                    }
                </div>
            </div>
            {/*  Add ---------------------------------------------------------------------- */}

            {/*  Delete & Update ---------------------------------------------------------- */}
            {
                bamboo_delete.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Hapus Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_delete('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Data Akan Dihapus Pada Server Kami.</span>
                                            </div>
                                            <div onClick={() => {
                                                if(input[0].submit_file === true){
                                                    _uploads(`delete_${request_params}`)
                                                }else{
                                                    _uploads_post(`delete_${request_params}`)
                                                }
                                            }} className="_btn _cursor_pointer">
                                                Hapus
                                            </div>
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }

            {
                bamboo_update.length > 0 ?
                    <div className="_fmc_overlay">
                        <div className="_fmc_overlay_navbar">
                            <div className="_row _center_align">
                                <div className="_column">
                                    <p className="_font_size_18px">Perbaharui Data</p>
                                </div>
                                <div onClick={() => {
                                    set_bamboo_update('')
                                    set_path_client('')
                                }} className="_push_l_d _btn _cursor_pointer">
                                    Keluar
                                </div>
                            </div>
                        </div>
                        <div className="_fmc_overlay_content">
                            <div className="_container">
                                <div className="_lily_pad_h_d">
                                    <div className="_row _push_t_g _push_b_g">
                                        <div className="_column">
                                            <div className="_heading_bold _push_b_l">
                                                Cloud : <span className="_grey">Semua Data Akan Disimpan Pada Server Kami.</span>
                                            </div>
                                            {
                                                input && input.map((item, index) => (
                                                    <>
                                                        <div key={index} className="_relative _push_b_d">
                                                            <p style={{color: '#888', fontSize: 13, textTransform: item.text_transform}}>
                                                                <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                {
                                                                    item.name.replace(/_/g, " ")
                                                                }
                                                            </p>
                                                            {
                                                                item.element === 'text' ?
                                                                    <div className="_e_input">
                                                                        <input 
                                                                            placeholder=""
                                                                            type={'text'} 
                                                                            onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                            value={eval(item.name)}
                                                                        />
                                                                    </div>
                                                                : item.element === 'dropdown' ?                  
                                                                    <div className="_e_input">
                                                                        <div className="_row _center_align">
                                                                            <div className="_column">
                                                                                <input 
                                                                                    placeholder=""
                                                                                    type={'text'} 
                                                                                    onChange={e => eval('set_' + item.name)(e.target.value)}
                                                                                    value={eval(item.name)}
                                                                                />
                                                                            </div>
                                                                            <div onClick={() => {
                                                                                if(sub_element === item.name + index){
                                                                                    set_sub_element(null)
                                                                                }else{
                                                                                    set_sub_element(item.name + index)
                                                                                }
                                                                            }} className="_btn _cursor_pointer" style={{backgroundColor: sub_element === item.name + index ? '#eee' : null}}>
                                                                                <div className="_row _center_align">
                                                                                    <div className="_push_t_t">
                                                                                        {
                                                                                            sub_element === item.name + index ?
                                                                                                <ion-icon name="chevron-up-outline"></ion-icon>
                                                                                            :
                                                                                                <ion-icon name="chevron-down-outline"></ion-icon>
                                                                                        }
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        <div className="_relative">
                                                                            {
                                                                                sub_element === item.name + index ?
                                                                                    // _left or _right
                                                                                    <>
                                                                                        <div className="_fmc_overlay_dropdown _right">
                                                                                            {
                                                                                                item.data && item.data.map((x, i) => (
                                                                                                    <div key={i} onClick={() => {eval('set_' + item.name)(x.name)}} className="_item" style={{backgroundColor: eval('set_' + item.name) === x.name ? '#eee' : null}}>{x.name}</div>
                                                                                                ))
                                                                                            }                                                                                                    </div>
                                                                                    </>
                                                                                : null
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                : item.element === 'money' ?
                                                                    <div className="_relative _push_b_d">
                                                                        <p style={{color: '#888', fontSize: 13}}>
                                                                            <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                                                                            Input
                                                                        </p>
                                                                        <div className="_e_input">
                                                                            <div className="_row _center_align">
                                                                                <div className="_push_r_t">
                                                                                    Rp.
                                                                                </div>
                                                                                <div className="_column">
                                                                                    <CurrencyFormat 
                                                                                        value={input} 
                                                                                        thousandSeparator={true} 
                                                                                        prefix={''}
                                                                                        onValueChange={(e) => {
                                                                                            if(e.value.length < 10){
                                                                                                set_input(e.value)
                                                                                            }else{
                                                                                                set_input('')
                                                                                                error('Max Length')
                                                                                            }
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                : item.element === 'file' ?
                                                                    <div className="_bb-input _push_b_d" style={{marginTop: -16}}>
                                                                        <div className="_e_input">
                                                                            <input
                                                                                className="custom-file-input" 
                                                                                type="file"
                                                                                name="file"
                                                                                placeholder=""
                                                                                onChange={_files}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                : item.element === 'submit' ?
                                                                    <div className="_push_t_d">
                                                                        <div onClick={() => {
                                                                            if(item.submit_file === true){
                                                                                if(file === null){
                                                                                    _uploads(`update_text_${request_params}`)
                                                                                }else{
                                                                                    _uploads(`update_file_${request_params}`)
                                                                                }
                                                                            }else{
                                                                                _uploads_post(`update_${request_params}`)
                                                                            }
                                                                        }} className="_btn _cursor_pointer">
                                                                            Simpan
                                                                        </div>
                                                                    </div>
                                                                : null
                                                            }
                                                        </div>
                                                    </>
                                                ))
                                            }
                                        </div>
                                        <div className="_fmc_overlay_bg_hide">
                                            <img style={{width: 400}} src={OverlayBg}/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                : null
            }
            {/*  End Delete & Update ------------------------------------------------------- */}


            {/*  Search -------------------------------------------------------------------- */}
            <div className="_bb_search _push_b_d" style={{backgroundColor: 'transparent'}}>
                <div className="_row _center_align">
                    <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                    <div className="_column">
                        <input 
                            placeholder="Cari" 
                            onChange={e => set_search(e.target.value)}
                            value={search}
                        />
                    </div>
                </div>
            </div>
            {/*  End Search ---------------------------------------------------------------- */}

            {/*  Table --------------------------------------------------------------------- */}
            <div className="_data_table_transition" style={{height: table_height}}>
                <div className="_overflow_x" ref={ref_table_height}>
                    <table className="_table">
                        <thead>
                            <tr>
                                <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                                {
                                    input && input.map((x, i) => {
                                        if(x.element !== 'submit'){
                                            if(x.show_table === true){
                                                return(
                                                    <th style={{textTransform: x.text_transform}}>{x.name.replace(/_/g, " ")}</th>
                                                )
                                            }
                                        }
                                    })
                                }
                                <th>
                                    <div className="_right_text">
                                        <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                    </div>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                data && data.list.length > 0 ? 
                                    data.list.map((item, index) => (
                                        <tr key={index}>
                                            <td>{index + 1}</td>
                                            {/* <td>
                                                <a href={API_SERVER + '/' + item.path + '/' + item.file} target="_blank"><ion-icon name="image-outline" style={{fontSize: 22, marginBottom: -3}}></ion-icon></a>
                                            </td> */}
                                            {
                                                input && input.map((x, i) => {
                                                    if(x.element !== 'submit'){
                                                        if(x.show_table === true){
                                                            return(
                                                                <td>{eval('item.' + x.name)}</td>
                                                            )
                                                        }
                                                    }
                                                })
                                            }
                                            <td>
                                                <div className="_right_text _text_overflow">
                                                    <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_delete(item.bamboo)
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Delete
                                                    </div>
                                                    <div onClick={() => {
                                                        set_path_client(item.path)
                                                        set_bamboo_update(item.bamboo)
                                                        // update state -------------------------
                                                        set_test(decode(item.test))
                                                        
                                                        input && input.map((x, i)=> {
                                                            if(x.element !== 'submit'){
                                                                eval('set_' + x.name)(eval('item.' + x.name)
                                                            )}
                                                        })
                                                    }} className="_btn _cursor_pointer _push_r_m">
                                                        Update
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    ))

                                :
                                    data &&
                                    <tr>
                                        <td colSpan="10">Belum Ada Data</td>
                                    </tr>
                            }
                        </tbody>
                    </table>
                </div>
            </div>
            {/*  End Table ----------------------------------------------------------------- */}

            {/*  Pagination ---------------------------------------------------------------- */}
            <div className="_lily_pad_h_d _push_b_d _push_t_d">
                <div className="__pagination">
                    {
                        data&&data.pages.map((item, index) => {
                            if(data.pages.length > 1){
                                return (

                                    <div 
                                        key={index} 
                                        className="__item"
                                        style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                        onClick={() => {
                                            _read(index + 1, bamboo_user);
                                            set_pagination_active(index + 1)
                                        }}
                                    >
                                        <div className="_position_middle">
                                            {item}
                                        </div>
                                    </div>
                                    
                                )
                            }
                        })
                    }
                </div>
            </div>
            {/*  End Pagination -------------------------------------------------------------*/}

            {/*  Credit -------------------------------------------------------------------- */}
            {
                data && 
                    data.pages.length === 1 ?
                        <ComponentsCredit/>
                    :
                        data && data.list.length > 0 ?
                            null
                        :
                            <ComponentsCredit/>
                            
            }
            {/*  End Credit ---------------------------------------------------------------- */}

            {/*  Documentation ------------------------------------------------------------- */}

                {/* <div className="_row _center_align">
                    <div className="_column">

                    </div>
                    <div className="_column">
                        
                    </div>
                </div> */}

                {/* <div onClick={() => {
                    if(element === 'overlay'){
                        set_element(null)
                    }else{
                        set_element('overlay')
                    }
                }} className="_btn _cursor_pointer">
                    fmc overlay btn
                </div>

                {
                    element === 'overlay' ?
                        <>
                            <div className="_fmc_overlay">
                                <div className="_fmc_overlay_navbar">
                                    <div className="_row _center_align">
                                        <div className="_column">
                                            <p className="_font_size_18px">Overlay</p>
                                        </div>
                                        <div onClick={() => {
                                            if(element === 'overlay'){
                                                set_element(null)
                                            }else{
                                                set_element('overlay')
                                            }
                                        }} className="_push_l_d _btn _cursor_pointer">
                                            Keluar
                                        </div>
                                    </div>
                                </div>
                                <div className="_fmc_overlay_content">

                                </div>
                            </div>
                        </>
                    : null
                }

                <div className="_relative">
                    <div onClick={() => {
                        if(element === 'overlay_dropdown'){
                            set_element(null)
                        }else{
                            set_element('overlay_dropdown')
                        }
                    }} className="_btn _cursor_pointer">
                        <div className="_row _center_align">
                            <div className="_column">
                                fmc overlay dropdown btn
                            </div>
                            <div className="_push_l_m _push_t_t">
                                {
                                    element === 'overlay_dropdown' ?
                                        <ion-icon name="chevron-up-outline"></ion-icon>
                                    :
                                        <ion-icon name="chevron-down-outline"></ion-icon>
                                }
                            </div>
                        </div>
                    </div>
                    {
                        element === 'overlay_dropdown' ?
                            // _left or _right
                            <>
                                <div className="_fmc_overlay_dropdown _left">
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                    <div onClick={() => {}} className="_item">1. oke</div>
                                </div>
                            </>
                        : null
                    }
                </div>

                <div className="_relative _push_b_m">
                    <p style={{color: '#888', fontSize: 13}}>
                        <ion-icon name="ellipse-outline" style={{marginRight: 8, fontSize: 12}}></ion-icon>
                        Input
                    </p>
                    <div className="_e_input">
                        <input 
                            placeholder=""
                            type={'text'} 
                            // onChange={e => set_input(e.target.value)}
                            // value={input}
                        />
                    </div>
                </div>

                <div className="_bb-input" style={{paddingBottom: 10, paddingTop: 10}}>
                                        
                    <input
                        className="custom-file-input" 
                        type="file"
                        name="file"
                        placeholder=""
                        onChange={_files}
                    />

                </div>

                <div onClick={() => {
                    _uploads()
                }} className="_btn _cursor_pointer">
                    Simpan
                </div>

                <div className="_bb_search" style={{backgroundColor: 'transparent'}}>
                    <div className="_row _center_align">
                        <ion-icon name="search-outline" style={{fontSize: 20}}></ion-icon>
                        <div className="_column">
                            <input 
                                placeholder="Cari" 
                                onChange={e => set_search(e.target.value)}
                                value={search}
                            />
                        </div>
                    </div>
                </div>

                <div className="_overflow_x">
                    <table className="_table">
                        <thead>
                            <th style={{width: 60}}><ion-icon name="rocket-outline" style={{fontSize: 22}}></ion-icon></th>
                            <th>Title</th>
                            <th>Description</th>
                            <th>Category</th>
                            <th>
                                <div className="_right_text">
                                    <ion-icon name="magnet-outline" style={{fontSize: 24}}></ion-icon>
                                </div>
                            </th>
                        </thead>
                        <tbody>
                            <tr>
                                <td colSpan="5"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
                <div className="_lily_pad_h_d _push_b_d _push_t_d">
                    <div className="__pagination">
                        {
                            data&&data.pages.map((item, index) => {
                                if(data.pages.length > 1){
                                    return (

                                        <div 
                                            key={index} 
                                            className="__item"
                                            style={{backgroundColor: pagination_active === index + 1 ? '#eee' : '#fff'}}
                                            onClick={() => {
                                                _read(index + 1);
                                                set_pagination_active(index + 1)
                                            }}
                                        >
                                            <div className="_position_middle">
                                                {item}
                                            </div>
                                        </div>
                                        
                                    )
                                }
                            })
                        }
                    </div>
                </div> */}

                {/* <NavLink 
                    to='/sims/export/rapor'
                    className="_btn _cursor_pointer"
                >
                    Export PDF
                </NavLink> */}
                
            {/*  End Documentation --------------------------------------------------------- */}
            
            {/*  Stuck --------------------------------------------------------------------- */}
            {/* <div style={{height: 100}}></div> */}
            {/*  End Stuck ----------------------------------------------------------------- */}

        </>
    );

}

export default Screen;